import { render, staticRenderFns } from "./ButtonChild.vue?vue&type=template&id=47e22fbf&scoped=true&"
import script from "./ButtonChild.vue?vue&type=script&lang=js&"
export * from "./ButtonChild.vue?vue&type=script&lang=js&"
import style0 from "./ButtonChild.vue?vue&type=style&index=0&id=47e22fbf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e22fbf",
  null
  
)

export default component.exports